import { Component, Input, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { Observable } from 'rxjs';

export interface MonitoringWeatherData {
	icon: string[];
	temperature: number[];
	wind_speed: number[];
	wind_direction: number[];
	timestamp: number[];
}
@Component({
    selector: 'app-monitoring-weather',
    templateUrl: './monitoring-weather.component.html',
    styleUrls: ['./monitoring-weather.component.scss'],
    standalone: false
})
export class MonitoringWeatherComponent implements OnChanges {

  @ViewChild('spdrow', { static: true }) wSpeedRow: ElementRef;
  public unitsColumnStyle = {};
  public firstColumnStyle = {};
  public lastColumnStyle = {};
  public totalMargin: number;
  public theme$: Observable<EThemeName>;

  @Input() weatherData: MonitoringWeatherData;

  constructor(private themeService: ThemeService) {
    this.theme$ = this.themeService.getTheme();
  }

  ngOnChanges() {
    this.calcStyles(this.weatherData, 24);
  }

  public rotate(value: number) {
    return { transform: 'rotate(' + (+value + 180) + 'deg)' };
  }

  private calcStyles(dataSeries: any, rangeHours: number) {
    this.unitsColumnStyle = {};
    this.firstColumnStyle = {};
    this.lastColumnStyle = {};
    if (dataSeries && dataSeries.length > 0) {
      let minutes = 60 - new Date(dataSeries[0].timestamp).getMinutes();
      if (minutes === 60) {
        minutes = 0;
      }
      if (rangeHours === 6) {
        const marginLeft = Math.round(-57 + minutes * 2.4);
        const marginRight = Math.round(75 - minutes * 2.4);
        this.totalMargin = marginLeft + marginRight;
        this.unitsColumnStyle = { 'margin-left': marginLeft > 0 ? ((marginLeft / 2) + 'px') : '3px' };
        this.firstColumnStyle = { 'margin-left': marginLeft > 0 ? ((marginLeft / 2) + 'px') : marginLeft + 'px' };
        this.lastColumnStyle = { 'margin-right': marginRight + 'px' };
      } else {
        const marginLeft = Math.round(-3 + minutes * 0.65);
        const marginRight = Math.round(25 - minutes * 0.65);
        this.totalMargin = marginLeft + marginRight;
        this.unitsColumnStyle = { 'margin-left': marginLeft > 0 ? ((marginLeft / 2) + 'px') : '3px' };
        this.firstColumnStyle = { 'margin-left': marginLeft > 0 ? ((marginLeft / 2) + 'px') : marginLeft + 'px' };
        this.lastColumnStyle = { 'margin-right': marginRight + 'px' };
      }
    }
  }

}
